export const cleanClerkError = (err: any, defaultErr?: string): string => {
  const mainError = err?.errors?.[0];

  switch (mainError?.code) {
    case 'form_param_format_invalid':
      return `This email has an invalid character. Please double-check your email address above.`;
    case 'form_identifier_not_found':
      return `This email account is not yet registered. Please sign up first on the next tab`;
    default:
      return err?.errors?.[0]?.message ?? defaultErr ?? 'An error occurred';
  }
};
